export const BRAND = {
  name: "HomeCure",
  parent: "MESRON HEALTHCARE LLP",
  llpin: "ACD-8580",
  tagline: "Healthcare at Your Doorstep",
  website: "www.homecure.co.in",
  email: "admin@homecure.co.in",
  phone: "+91-9002296906",
  whatsapp: "+91-9002296906",
  grievanceOfficer: "Dr. Indranil Chatterjee",
  address:
    "Premises No.159/63, Street No.2, Hindusthan Park, Hirapur, Asansol - 713304, West Bengal, India",
  cities: ["Asansol", "Durgapur", "Bardhaman"],
  logoUrl: "/assets/logo.png",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/for-patients", label: "For Patients" },
  { to: "/for-hospitals", label: "For Hospitals" },
  { to: "/for-personnel", label: "For Personnel" },
  { to: "/contact", label: "Contact" },
];
